import { fetchBudgetingScenarios } from '../../service/budgetingScenarioService'
import budgetingScenarioQueryKeys from './budgetingScenarioQueryKeys'
import { sortById } from '../../../../utils/helpers'
import { BudgetingScenario } from '../../types/BudgetingScenario'
import { normalizeScenario } from '../../utils/scenarioUtils'

export const getBudgetingScenarioOptions = <TData = BudgetingScenario[]>(
  companyId: string,
  select?: (data: BudgetingScenario[]) => TData
) => {
  return {
    queryKey: budgetingScenarioQueryKeys.list(companyId),
    queryFn: fetchBudgetingScenarios,
    gcTime: 15 * 60 * 1000,
    enabled: !!companyId,
    select: (data: BudgetingScenario[]) => {
      const sortedData = sortById(data)
      const normalizedData = sortedData.map(normalizeScenario)

      return select ? select(normalizedData) : (normalizedData as TData)
    }
  }
}
